import qs from 'qs'

export default class FeefoAdapter {
  constructor ({feefoMerchantidentifier, feefoUrl, httpClient} = {}) {
    this.feefoMerchantidentifier = feefoMerchantidentifier
    this.feefoUrl = feefoUrl
    this.httpClient = httpClient
  }

  async getParentTourCode (tourCode) {
    const response = await this.getProductRating(tourCode)

    return response && response.product && response.product.parent_sku
  }

  async getProductRating (tourCode) {
    const queryParameters = {
      merchant_identifier: this.feefoMerchantidentifier,
      product_sku: tourCode,
      since_period: 'ALL',
      unanswered_feedback: 'exclude',
    }

    const path = `reviews/summary/product`
    const url = `${this.feefoUrl}${path}?${qs.stringify(queryParameters)}`

    return await this.httpClient.get(url)
  }

  async getParentRating (tourParentCode) {
    const queryParameters = {
      merchant_identifier: this.feefoMerchantidentifier,
      parent_product_sku: tourParentCode,
      since_period: 'ALL',
      unanswered_feedback: 'exclude',
    }

    const path = `reviews/summary/product`
    const url = `${this.feefoUrl}${path}?${qs.stringify(queryParameters)}`

    return await this.httpClient.get(url)
  }

  async getMerchantRating () {
    const queryParameters = {
      merchant_identifier: this.feefoMerchantidentifier,
    }

    const path = `reviews/summary/all`
    const url = `${this.feefoUrl}${path}?${qs.stringify(queryParameters)}`

    return await this.httpClient.get(url)
  }
}
